import { gql } from 'react-apollo';

export default gql`
  mutation updateInvestorQualification(
    $accreditationType: AccreditationType!
    $qualifications: [InvestorQualification]!
    $selectedOptionTypes: String
    $centeralRegistrationNumber: String
    $institutionalOther: String
    $individualOther: String
    $nonOtherAccreditionText: String
    $intendInvestingFunds: String
    $benefitInvestor: String
    $benefitInvestorQuestions: String
    $qualifiedPurchaserQuestion: String
    $qualifiedPurchaser: String
    $benefitInvestorQuestionsOther: String
    $qualifiedPurchaseOther: String
  ) {
    updateInvestorQualification(
      input: {
        accreditationType: $accreditationType
        qualifications: $qualifications
        selectedOptionTypes: $selectedOptionTypes
        centeralRegistrationNumber: $centeralRegistrationNumber
        institutionalOther: $institutionalOther
        individualOther: $individualOther
        nonOtherAccreditionText: $nonOtherAccreditionText
        intendInvestingFunds: $intendInvestingFunds
        benefitInvestor: $benefitInvestor
        benefitInvestorQuestions: $benefitInvestorQuestions
        qualifiedPurchaserQuestion: $qualifiedPurchaserQuestion
        benefitInvestorQuestionsOther: $benefitInvestorQuestionsOther
        qualifiedPurchaser: $qualifiedPurchaser
        qualifiedPurchaseOther: $qualifiedPurchaseOther
      }
    ) {
      _id
      canViewOffers
      accreditationStatus
      accreditationType
      qualifications
      selectedOptionTypes
      intendInvestingFunds
      centeralRegistrationNumber
      institutionalOther
      nonOtherAccreditionText
      individualOther
      qualifiedPurchaser
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateInvestorQualification.js